import { Fragment, useCallback, useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';

import { Dropdown, getColor, QueryDropdown, Switch } from 'basic-components';
import { DataStorageEnums } from 'dashboard-services';

import { TimeSeriesUtils } from 'utils';

import SectionTitle from '../SectionTitle';
import MetadataLabel from './MetadataLabel';

import { When } from 'react-if';

const emptyArray = []
const OutputType = ({ formatType, csvHeaders, shouldTranspose, onChange, withTranspose, withOutputType, children, additionalCsvHeaders, keys, isPendingKeys, setKeyQuery }) => {
  const callsRefs = useRef([]),
        
        localformatTypesArray = useMemo(() => [
          {
            label: DataStorageEnums.DATA_FORMAT.NCSV,
            value: DataStorageEnums.DATA_FORMAT.NCSV,
          },
          {
            label: DataStorageEnums.DATA_FORMAT.CSV,
            value: DataStorageEnums.DATA_FORMAT.CSV
          }
        ], []),
        
        localFormatType = useMemo(() => localformatTypesArray.find(f => f.value === formatType), [formatType, localformatTypesArray]),
        onChangeBool = useCallback((val, { name }) => onChange(String(val), { name }), [onChange]),
        onChangeHeader = useCallback((_, { name, data }) => onChange(data.map(obj => ({ name: obj.value, type: obj.type })), { name }), [onChange]),
        defaultCsvHeaders = useMemo(() => csvHeaders?.map(header => {
            const defaultOne = additionalCsvHeaders.find(c => c.value === header.name)
            if(defaultOne) {
              return defaultOne
            } else {
              return {
                value: header.name, 
                label: header.type === DataStorageEnums.CSV_HEADER_TYPE.METADATA_KEY ? (<MetadataLabel name={header.name}/>) : header.name,
                color: header.type === DataStorageEnums.CSV_HEADER_TYPE.METADATA_KEY ? getColor("grey-dark") : undefined,
                type: header.type
              }
            }
          }), [additionalCsvHeaders, csvHeaders]),
          keysWithAdditional = useMemo(() => isPendingKeys ? emptyArray : additionalCsvHeaders.concat(keys), [additionalCsvHeaders, isPendingKeys, keys]) 

  useEffect(() => () => {
    callsRefs.current.forEach(promiseObj => promiseObj?.cancel())
  }, [])

  return (
    <Fragment>
      <SectionTitle>
        CONFIGURATION
      </SectionTitle>
      <When condition={withOutputType}>
        {() => (
          <Fragment>
            <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__label">
              Output type
            </div>
            <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__value">
              <Dropdown
                  defaultValue={localFormatType}
                  fixed
                  menuPortalTarget={document.querySelector('.ng-office-app')}
                  name="formatType"
                  noError
                  onChange={onChange}
                  options={localformatTypesArray}
                  variant="border"
              />
            </div>
          </Fragment>
        )}
      </When>
      <When condition={formatType === DataStorageEnums.DATA_FORMAT.CSV}>
        {() => (
          <Fragment>
            <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__label">
              Column header
            </div>
            <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__value">
              <QueryDropdown
                  defaultValue={defaultCsvHeaders}
                  fixed
                  isFetching={isPendingKeys}
                  menuPortalTarget={document.querySelector('.ng-office-app')}
                  multi
                  name="csvHeaders"
                  noError
                  onChange={onChangeHeader}
                  onInputChange={setKeyQuery}
                  openMenuOnFocus
                  options={keysWithAdditional}
                  variant="border"
              />
            </div>
          </Fragment>
        )}
      </When>
      <When condition={withTranspose}>
        {() => (
          <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__switch">
            <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__label">
              Transpose the result
            </div>
            <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__value">
              <Switch
                  name="shouldTranspose"
                  noError
                  on={shouldTranspose === "true"}
                  onChange={onChangeBool}
              />
            </div>
          </div>
        )}
      </When>
      {children}
    </Fragment>
  )
}

OutputType.defaultProps = {
  additionalCsvHeaders: TimeSeriesUtils.csvHeadersOptions,
  children: undefined,
  csvHeaders: [],
  formatType: undefined,
  keys: [],
  shouldTranspose: "false",
  withOutputType: false,
  withTranspose: false
}

OutputType.propTypes = {
  additionalCsvHeaders: PropTypes.array,
  children: PropTypes.any, 
  csvHeaders: PropTypes.array, 
  formatType: PropTypes.string, 
  isPendingKeys: PropTypes.bool.isRequired,
  keys: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  setKeyQuery: PropTypes.func.isRequired,
  shouldTranspose: PropTypes.string, 
  withOutputType: PropTypes.bool,
  withTranspose: PropTypes.bool,
}

export default OutputType;